// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__W4xU3","bigColWidth":"Table_bigColWidth__3_8Is","biggerColWidth":"Table_biggerColWidth__3zAXF","row":"Table_row__1oeyF","col":"Table_col__3PTkh"};